module.exports = __webpack_public_path__ + "img/change-site-settings.924d6825.png";